import { useSelector } from "react-redux";
export default function Loading() {
    const loading = useSelector(state => {
        return state.setting.loading
    });
    return (
        <> { loading && <div className='loading'><div className='circle' /></div> } </>
    );
}